import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-right",
  "use": "chevron-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"chevron-right\"><path d=\"M12 8.055 5.541 15l-1.453-1.563 5.006-5.382L4 2.563 5.453 1 12 8.055Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol